import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { format } from 'date-fns'
import { z } from 'zod'

const propertyRestrictionsSearchSchema = z.object({
  month: z.string().catch(format(new Date(), 'MM')),
  year: z.number().catch(Number(format(new Date(), 'yyyy'))),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/inventories/property-restrictions/'
)({
  validateSearch: (search) => propertyRestrictionsSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ({ error }) => <ErrorComponent error={error} customMessage />,
})
